export default "__VITE_ASSET__D3a1Rq_J__"